import React, { useState } from 'react';
import { TextField, Button, Typography } from '@mui/material'; // Removed Box, Grid, Paper
import { useNavigate, Link } from 'react-router-dom'; // Added Link

function Register() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setSuccess('');

    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    try {
      const response = await fetch('/api/auth/register', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ name, email, password }),
      });

      if (response.ok) {
        setSuccess('Registration successful! Redirecting to login...');
        setTimeout(() => {
          navigate('/login');
        }, 2000);
      } else {
        const data = await response.json();
        setError(data.message || 'Registration failed');
      }
    } catch (error) {
      setError('There was an error during registration');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <div className="flex flex-col md:flex-row bg-white rounded-lg shadow-xl overflow-hidden w-full max-w-4xl">
        <div className="p-8 md:w-1/2 bg-gray-50 flex flex-col justify-center">
          <Typography variant="h4" component="h1" className="font-bold mb-4">
            Register
          </Typography>
          <form onSubmit={handleSubmit} className="space-y-4">
            <TextField
              label="Name"
              variant="outlined"
              fullWidth
              margin="normal"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
              className="rounded-md bg-white"
            />
            <TextField
              label="Email"
              variant="outlined"
              fullWidth
              margin="normal"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              type="email"
              className="rounded-md bg-white"
            />
            <TextField
              label="Password"
              variant="outlined"
              fullWidth
              margin="normal"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="rounded-md bg-white"
            />
            <TextField
              label="Confirm Password"
              variant="outlined"
              fullWidth
              margin="normal"
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              className="rounded-md bg-white"
            />
            {error && (
              <Typography color="error" variant="body2" className="mt-1 text-red-500">
                {error}
              </Typography>
            )}
            {success && (
              <Typography color="primary" variant="body2" className="mt-1 text-blue-500">
                {success}
              </Typography>
            )}
            <Button
              type="submit"
              variant="contained"
              fullWidth
              className="mt-3 py-3 bg-gradient-to-r from-purple-700 to-blue-600 rounded-md font-bold text-lg normal-case hover:from-blue-600 hover:to-purple-700 transition-all duration-300"
            >
              Register
            </Button>
          </form>
          <div className="mt-4 text-center">
            <Link to="/login" className="text-blue-600 hover:underline"> {/* Changed href to to */}
              Already have an account? Login
            </Link>
          </div>
        </div>
        <div
          className="md:w-1/2 bg-cover bg-center"
          style={{ backgroundImage: 'url(https://images.unsplash.com/photo-1504384308090-c894fdcc538d?auto=format&fit=crop&w=800&q=80)' }}
        />
      </div>
    </div>
  );
}

export default Register;
